export default [

  { title: 'My arbitration', routeName: 'arbitrator-my-arbitration' },

  { title: 'Others arbitration', routeName: 'arbitrator-others-arbitration' },


];
